const getQuestionnaireSectionIdentifier = section => {
    if (section.isCustom) {
        return `CUSTOM_SECTION_${section.id}`;
    }

    return `SECTION_${section.id}`;
};

export default getQuestionnaireSectionIdentifier;
